import EntityService from './EntityService'
import { Caregiver } from '@/store/model/definitions/User'

export default new EntityService<Caregiver>(
  process.env.VUE_APP_CAREGIVER_ENDPOINT ?? '',
  'caregiver'
)
